export const virtualListClasses = {
  root: 'virtual-list',
  list: 'virtual-list-wrapper',
}
